import React from "react";
import { SnackbarAction, useSnackbar } from "notistack";
import {
  Button,
  createStyles,
  IconButton,
  makeStyles,
  Theme,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

/** スタイル */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    icon: {
      color: theme.palette.primary.contrastText,
    },
    button: {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(1.0),
    },
  })
);

interface CustomAction {
  message: string;
  action: () => void;
}

/**
 * メッセージバー表示フック
 */
export function useMessageBar() {
  const classes = useStyles();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  /**
   * 閉じる
   * @param key スナックバー特定キー
   */
  const snackAction = (
    key: string | number | undefined,
    customAction?: CustomAction
  ): SnackbarAction => {
    const wrapAction = () => {
      closeSnackbar(key);
      if (customAction) {
        customAction?.action();
      }
    };
    return (
      <>
        {customAction && (
          <Button
            onClick={wrapAction}
            disabled={false}
            color="secondary"
            autoFocus
          >
            {customAction?.message}
          </Button>
        )}
        <IconButton
          onClick={() => {
            closeSnackbar(key);
          }}
          className={classes.button}
        >
          <CloseIcon className={classes.icon} fontSize="small" />
        </IconButton>
      </>
    );
  };

  /**
   * スナックバーを表示する
   * @param message 表示メッセージ
   */
  const enqueueMessge = (
    message: string,
    variant: "info" | "success" | "warning" | "error",
    autoHideDuration?: number,
    customAction?: CustomAction
  ): void => {
    enqueueSnackbar(message, {
      variant,
      persist: false,
      action: key => snackAction(key, customAction),
      preventDuplicate: false,
      autoHideDuration,
    });
  };
  return enqueueMessge;
}

export default useMessageBar;
